import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBSpinner
} from "mdbreact";
import cx from "classnames";
import React from "react";
import { connect } from "react-redux";
import { client } from "~/utils/medproSDK";
import { openToast } from "~/components/common/molecules/ToastNotification";
import { validatePhoneNumber } from "~/utils/func";
import Care247ServiceApply from "~/components/common/molecules/Care247ServiceApply";
import SkeletonInput from "~/components/common/atoms/SkeletonInput";
import styles from "./style.module.scss";

class ModalCare247Pay extends React.Component {
  state = {
    phone: "",
    sectionGroupAnimate: false,
    sendingSMS: false,
    loadingCare247Pay: false
  };

  handlePhoneChange = e => {
    this.setState({ phone: e.target.value });
  };

  handleCopy = () => {
    const { dataIndependent } = this.props;
    if (dataIndependent?.link) {
      var textArea = document.createElement("input");
      textArea.value = dataIndependent.link;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Failed to copy:", err);
      }

      document.body.removeChild(textArea);

      openToast("Đường dẫn đã được sao chép!");
    } else {
      openToast("Không có đường dẫn để sao chép!", "error");
    }
  };

  handleSendSMS = async () => {
    const { dataIndependent } = this.props;
    const { phone } = this.state;

    // Kiểm tra số điện thoại hợp lệ
    if (!validatePhoneNumber(phone)) {
      openToast("Số điện thoại không hợp lệ!", "error");
      return;
    }

    // Bắt đầu loading
    this.setState({ sendingSMS: true });

    try {
      // Gọi API chỉ với số điện thoại
      await client.sendSmsCare247PaymentIndependent({
        phone,
        token: dataIndependent.token
      });
      openToast("Đã gửi tin nhắn thành công!", "success");
    } catch (error) {
      console.log("error :>> ", error);
      openToast(
        `${error?.response?.data?.message || "Gửi tin nhắn thất bại!"}`,
        "error"
      );
    } finally {
      this.setState({ sendingSMS: false });
    }
  };

  getLinkCare = async (pkg = {}) => {
    this.setState({ loadingCare247Pay: true });
    await this.props.fetchCare247Pay({
      ...this.props.billInfo,
      care247ServiceId: pkg?.id
    });
    this.setState({ loadingCare247Pay: false });
  };

  componentDidUpdate(prevProps) {
    if (this.props.dataIndependent && !prevProps.dataIndependent) {
      setTimeout(() => this.setState({ sectionGroupAnimate: true }), 10);
    }
    if (!this.props.dataIndependent && prevProps.dataIndependent) {
      this.setState({ sectionGroupAnimate: false });
    }
  }

  render() {
    const {
      isOpen,
      toggle,
      dataIndependent,
      loadingTicket,
      dataCare247Services,
      loadingCare247Service,
      dataCheckVoucherCare247,
      loadingCheckVoucherCare247,
      errorCheckVoucherCare247,
      billInfo,
      onApply,
      onApplyVoucher
      // loadingCare247Pay
    } = this.props;
    const { loadingCare247Pay } = this.state;
    return (
      <MDBModal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={false}
        className={styles.ModalSendBooking}
      >
        <MDBModalHeader toggle={toggle} className={styles.header}>
          Dịch vụ giúp việc cá nhân - Care247
        </MDBModalHeader>
        <MDBModalBody>
          <div className={styles.modalBody}>
            <Care247ServiceApply
              loadingCare247Service={loadingCare247Service}
              billInfo={billInfo}
              dataCare247Services={dataCare247Services}
              dataCheckVoucherCare247={dataCheckVoucherCare247}
              loadingCheckVoucherCare247={loadingCheckVoucherCare247}
              errorCheckVoucherCare247={errorCheckVoucherCare247}
              onApply={this.getLinkCare}
              onApplyVoucher={onApplyVoucher}
            />
            {loadingCare247Pay ? (
              <div className={cx(styles.sectionGroup, styles.spinnerCenter)}>
                <MDBSpinner crazy />
              </div>
            ) : (
              <div className={cx(styles.sectionGroup)}>
                <div
                  className={cx(styles.sectionDataGroup, {
                    [styles.show]: this.state.sectionGroupAnimate
                  })}
                >
                  <div className={styles.section}>
                    <label className={styles.label}>
                      <i className="fas fa-link" style={{ marginRight: 4 }} />
                      Đường dẫn thanh toán DV đặt thêm Care247:
                    </label>
                    <div className={styles.copyRow}>
                      {loadingTicket ? (
                        <SkeletonInput loading={loadingTicket} />
                      ) : (
                        <input
                          className={styles.input}
                          type="text"
                          value={dataIndependent?.link}
                          readOnly
                        />
                      )}
                      <MDBBtn
                        color="primary"
                        className={styles.copyBtn}
                        onClick={this.handleCopy}
                        disabled={!dataIndependent?.link || loadingTicket}
                      >
                        SAO CHÉP
                      </MDBBtn>
                    </div>
                  </div>
                  <div className={styles.section}>
                    <label className={styles.label}>
                      <i
                        className="fas fa-mobile-alt"
                        style={{ marginRight: 4 }}
                      />
                      Gửi SMS:
                    </label>
                    <div className={styles.smsRow}>
                      <input
                        className={styles.input}
                        type="text"
                        placeholder="Nhập số điện thoại"
                        value={this.state.phone}
                        onChange={this.handlePhoneChange}
                      />
                      <MDBBtn
                        color="primary"
                        className={styles.sendBtn}
                        onClick={this.handleSendSMS}
                        disabled={this.state.sendingSMS}
                      >
                        {this.state.sendingSMS ? (
                          <>
                            <i
                              className="fas fa-spinner fa-spin"
                              style={{ marginRight: 4 }}
                            />
                            ĐANG GỬI...
                          </>
                        ) : (
                          "GỬI"
                        )}
                      </MDBBtn>
                    </div>
                  </div>
                </div>
                {!dataIndependent ? (
                  <div className={styles.sectionDataEmpty}>
                    Vui lòng chọn gói lấy link thanh toán care247!
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </MDBModalBody>
      </MDBModal>
    );
  }
}

const mapStateToProps = state => {
  const {
    customerService: { historyBooking }
  } = state;
  return {
    historyBooking
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ModalCare247Pay);
